/**
 * Funcionalidad global de vue router
 * para regresar atras en la navegación
 */
// Dependencias
import router from '../router';

export default () => {
  router.go(-1);
};
